
export interface AppConfigType {
    BaseUrl?: string,
    ApiKey?: string,
    ClientId?: string,
    TenantId?: string,
    GraphApi?: string,
    AzBaseUrl?:string,
    AzApiKey?:string,
    SecretAccessKey?:string,
    AccessKeyId?:string,
    ApiAdminScope: string,
    ApiUserScope: string,
    environment?: string
}

const ApiConfig: AppConfigType = {
    BaseUrl: process.env.REACT_APP_API_URL,
    ApiKey: process.env.REACT_APP_API_KEY,
    ClientId: process.env.REACT_APP_CLIENT_ID,
    TenantId: process.env.REACT_APP_TENANT_ID,
    GraphApi: process.env.REACT_APP_GRAPH_API,
    AzBaseUrl: process.env.REACT_APP_AZ_SEARCH_API_URL,
    AzApiKey: process.env.REACT_APP_AZ_SEARCH_API_KEY,
    SecretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    AccessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
    ApiAdminScope: process.env.REACT_APP_API_ADMIN_SCOPE!,
    ApiUserScope: process.env.REACT_APP_API_USER_SCOPE!,
    environment: process.env.REACT_APP_ENVIRONMENT,
}

export const AppConfig = (): AppConfigType => {
    return ApiConfig;
}

export default AppConfig;
